var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5992 6.3542L11.955 2.5717C10.8225 1.64587 9.17836 1.6467 8.04503 2.57087L3.40253 6.35337C2.6767 6.9417 2.26086 7.8142 2.26086 8.74757V14.7309C2.26086 16.6009 3.78253 18.1226 5.65336 18.1226H9.37336V13.1059C9.37336 12.7601 9.65336 12.4809 9.99836 12.4809C10.3434 12.4809 10.6234 12.7601 10.6234 13.1059V18.1226H14.3459C16.2175 18.1226 17.7392 16.6009 17.7392 14.7309V8.74757C17.7392 7.81337 17.3234 6.9417 16.5992 6.3542Z",
    fill: "#969696"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.d6554cfb0e9d6d9a8a1e97727fc5628c.svg";
export { ForwardRef as ReactComponent };